import { useEffect } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';

type Props = {
  themeDirection: 'rtl' | 'ltr';
  children: React.ReactNode;
};

// Create rtl cache following MUI documentation
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function RTL({ children, themeDirection }: Props) {
  useEffect(() => {
    document.dir = themeDirection;
  }, [themeDirection]);

  if (themeDirection === 'rtl') {
    return (
      <CacheProvider value={cacheRtl}>
        <div suppressHydrationWarning={true}>{children}</div>
      </CacheProvider>
    );
  }

  return <>{children}</>;
}
